var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dtp-table"},[_c('lk-table',{attrs:{"border":_vm.border,"columns":_vm.columns,"data":_vm.data,"disabledHover":_vm.disabledHover}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }